import React from "react"
import { Box, Divider, List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { map } from "lodash"
import DarkModeIcon from "@mui/icons-material/DarkMode"
import LightModeIcon from "@mui/icons-material/LightMode"
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"
import HelpOutlineIcon from "@mui/icons-material/HelpOutline"
import { ThemeMode } from "@/shared/context/ThemeContext"
import { LOW_CREDITS_THRESHOLD } from "@/shared/constants/plans"
import BoostCreditsCard from "@/features/billing/components/BoostCreditsCard"

interface FooterItem {
  key: string
  label: string
  icon: React.ReactNode
  onClick: () => void
}

interface Props {
  mode: ThemeMode
  toggleTheme: () => void
  creditsRemaining: number
  onNavigate: () => void
}

const FEEDBACK_MAILTO = "mailto:reymishra08@gmail.com?subject=ListYourProduct%20feedback"

const SidebarFooter: React.FC<Props> = ({ mode, toggleTheme, creditsRemaining, onNavigate }) => {
  const navigate = useNavigate()
  const isLowCredits = creditsRemaining <= LOW_CREDITS_THRESHOLD

  const items: FooterItem[] = [
    {
      key: "theme",
      label: mode === "dark" ? "Light mode" : "Dark mode",
      icon: mode === "dark" ? <LightModeIcon fontSize="small" /> : <DarkModeIcon fontSize="small" />,
      onClick: toggleTheme
    },
    {
      key: "about",
      label: "About",
      icon: <InfoOutlinedIcon fontSize="small" />,
      onClick: () => {
        onNavigate()
        navigate("/about")
      }
    },
    {
      key: "feedback",
      label: "Feedback",
      icon: <HelpOutlineIcon fontSize="small" />,
      onClick: () => {
        window.location.href = FEEDBACK_MAILTO
      }
    }
  ]

  return (
    <Box>
      <List dense disablePadding>
        {map(items, item => (
          <ListItemButton key={item.key} onClick={item.onClick}>
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.label} primaryTypographyProps={{ variant: "body2" }} />
          </ListItemButton>
        ))}
      </List>
      {isLowCredits && (
        <>
          <Box sx={{ px: 1.5, pt: 1.5 }}>
            <BoostCreditsCard creditsRemaining={creditsRemaining} onNavigate={onNavigate} />
          </Box>
          <Divider sx={{ mt: 1.5 }} />
        </>
      )}
    </Box>
  )
}

export default SidebarFooter
